let verify = {
    authenticationFailed: "Verification failed",
    authenticationSuccess: "Verification succeeded",
    turnClick: "Please click one by one",
    explain: "Swipe right to complete verification",
    safetyVerification: "Please complete security verification",
}

export default verify